"use client";

import { cn } from "@/lib/utils";
import { LEXIKON_CATEGORIES, type LexikonTerm } from "@/lib/lexikon";

type Category = LexikonTerm["category"];

/** Themen-Filter des Lexikons (Chips je Kategorie plus „Alle"). */
export default function CategoryFilter({
  active,
  counts,
  onSelect,
}: {
  active: Category | null;
  /** Anzahl Begriffe je Kategorie (für das Zähllabel). */
  counts: Record<Category, number>;
  onSelect: (category: Category | null) => void;
}) {
  const chip =
    "inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-colors cursor-pointer";

  return (
    <div
      role="group"
      aria-label="Nach Kategorie filtern"
      className="flex flex-wrap justify-center gap-2"
    >
      <button
        onClick={() => onSelect(null)}
        aria-pressed={active === null}
        className={cn(
          chip,
          active === null
            ? "bg-accent text-paper"
            : "bg-white border border-line text-ink-soft hover:border-accent hover:text-accent",
        )}
      >
        Alle Themen
      </button>
      {LEXIKON_CATEGORIES.map((category) => {
        const isActive = active === category;
        return (
          <button
            key={category}
            onClick={() => onSelect(isActive ? null : category)}
            aria-pressed={isActive}
            className={cn(
              chip,
              isActive
                ? "bg-accent text-paper"
                : "bg-white border border-line text-ink-soft hover:border-accent hover:text-accent",
            )}
          >
            {category}
            <span
              className={cn(
                "tnum text-xs font-bold",
                isActive ? "text-paper/70" : "text-ink-faint",
              )}
            >
              {counts[category] ?? 0}
            </span>
          </button>
        );
      })}
    </div>
  );
}
